module.exports = __webpack_public_path__ + "img/114.cb890aa3.jpg";